import { useStore } from 'Portal/src/stores'

export const useTaggingEnabled = () => {
  const { portalConfigStore } = useStore()

  return portalConfigStore.portalConfig?.enableTags ?? false
}
